/** Branch types the /discovery quote funnel can continue; others have their own funnel or none. */
export const CONTINUABLE_IN_QUOTE_FUNNEL = ['NEW_BUSINESS', 'MTA'];
